"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrlPathByEndpoint = exports.getBucketAndObjectKeysByUrn = void 0;
const getBucketAndObjectKeysByUrn = input => {
  const parts = input.split(":");
  const path = parts[parts.length - 1];
  const [bucketKey, objectKey] = path.split("/");
  return {
    bucketKey,
    objectKey
  };
};
exports.getBucketAndObjectKeysByUrn = getBucketAndObjectKeysByUrn;
const getUrlPathByEndpoint = (urn, endpoint) => {
  const {
    bucketKey,
    objectKey
  } = getBucketAndObjectKeysByUrn(urn);
  return "buckets/".concat(bucketKey, "/objects/").concat(objectKey, "/").concat(endpoint);
};
exports.getUrlPathByEndpoint = getUrlPathByEndpoint;
//# sourceMappingURL=ossHelpers.js.map